import { defineComponent as _defineComponent } from 'vue';
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withModifiers as _withModifiers, resolveComponent as _resolveComponent } from "vue";
const _hoisted_1 = { class: "questionnaires-page" };
const _hoisted_2 = { class: "tab-bar" };
const _hoisted_3 = {
    key: 0,
    class: "page-container"
};
const _hoisted_4 = { class: "item-info" };
const _hoisted_5 = { class: "item-name" };
const _hoisted_6 = { class: "item-meta" };
const _hoisted_7 = {
    key: 0,
    class: "badge quiz"
};
const _hoisted_8 = { class: "detail-section" };
const _hoisted_9 = { key: 0 };
const _hoisted_10 = { class: "section-header" };
const _hoisted_11 = { class: "header-actions-group" };
const _hoisted_12 = {
    key: 0,
    class: "json-editor-section"
};
const _hoisted_13 = {
    key: 0,
    class: "json-error"
};
const _hoisted_14 = { class: "form-row" };
const _hoisted_15 = { class: "form-group" };
const _hoisted_16 = { class: "form-group" };
const _hoisted_17 = { class: "form-row" };
const _hoisted_18 = { class: "form-group" };
const _hoisted_19 = { class: "form-group" };
const _hoisted_20 = { class: "checkbox-label" };
const _hoisted_21 = { class: "form-group" };
const _hoisted_22 = { class: "form-group" };
const _hoisted_23 = { class: "questions-section" };
const _hoisted_24 = { class: "section-header" };
const _hoisted_25 = ["disabled"];
const _hoisted_26 = {
    key: 0,
    class: "add-question-panel"
};
const _hoisted_27 = { key: 0 };
const _hoisted_28 = { class: "form-group" };
const _hoisted_29 = ["value"];
const _hoisted_30 = { class: "add-question-actions" };
const _hoisted_31 = { key: 1 };
const _hoisted_32 = ["onDragstart", "onDrop"];
const _hoisted_33 = ["onClick"];
const _hoisted_34 = { class: "chevron" };
const _hoisted_35 = { class: "question-item-text" };
const _hoisted_36 = {
    key: 0,
    class: "question-item-body"
};
const _hoisted_37 = {
    key: 2,
    class: "empty-state"
};
const _hoisted_38 = {
    key: 1,
    class: "empty-state-section"
};
const _hoisted_39 = {
    key: 1,
    class: "library-section"
};
const _hoisted_40 = { class: "section-header" };
const _hoisted_41 = { class: "subtitle" };
const _hoisted_42 = { class: "search-box" };
const _hoisted_43 = { key: 1 };
const _hoisted_44 = ["onClick"];
const _hoisted_45 = { class: "chevron" };
const _hoisted_46 = { class: "question-item-text" };
const _hoisted_47 = ["onClick"];
const _hoisted_48 = {
    key: 0,
    class: "question-item-body"
};
const _hoisted_49 = {
    key: 2,
    class: "empty-state"
};
const _hoisted_50 = { class: "usage-question" };
const _hoisted_51 = { key: 0 };
const _hoisted_52 = { class: "item-meta" };
const _hoisted_53 = ["onClick"];
const _hoisted_54 = { key: 1 };
import { ref, computed, watch, onMounted } from 'vue';
import { useAdmin } from '@/composables/useAdmin';
import MGDialog from '@/components/elements/MGDialog.vue';
import MGButton from '@/components/elements/MGButton.vue';
import AdminListSection from '@/admin/components/AdminListSection.vue';
import AdminHeaderActions from '@/admin/components/AdminHeaderActions.vue';
import QuestionCard from '@/admin/components/QuestionCard.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'QuestionnairesPage',
    setup(__props) {
        const admin = useAdmin();
        const tabIndex = ref(0);
        const selectedQuestionnaire = ref(null);
        const addingQuestion = ref(false);
        const creatingNewQuestion = ref(false);
        const creatingLibraryQuestion = ref(false);
        const expandedQuestionId = ref(null);
        const expandedLibraryQuestionId = ref(null);
        const draggedIndex = ref(null);
        const librarySearch = ref('');
        const showJsonEditor = ref(false);
        const jsonEditorContent = ref('');
        const jsonError = ref('');
        const showDeleteQuestionnaireDialog = ref(false);
        const showUsageDialog = ref(false);
        const usageQuestion = ref(null);
        const showToast = ref(false);
        const toastMessage = ref('');
        const toastColour = ref('success');
        const questionnaires = computed(() => admin.adminState.questionnaires);
        const questions = computed(() => admin.adminState.questions);
        const loading = computed(() => admin.adminState.questionsLoading);
        const blankQuestion = computed(() => ({ id: '', text: '', questionType: 0, possibleAnswers: [] }));
        const questionnaireQuestions = computed(() => selectedQuestionnaire.value?.questionnaireQuestions || []);
        const filteredLibraryQuestions = computed(() => {
            if (!librarySearch.value)
                return questions.value;
            const search = librarySearch.value.toLowerCase();
            return questions.value.filter((q) => q.text?.toLowerCase().includes(search) || q.key?.toLowerCase().includes(search));
        });
        const usageQuestionnaires = computed(() => {
            if (!usageQuestion.value)
                return [];
            return questionnaires.value.filter((q) => usesQuestion(q, usageQuestion.value.id));
        });
        function usesQuestion(questionnaire, questionId) {
            return (questionnaire.questionnaireQuestions || []).some((qq) => qq.questionId === questionId);
        }
        function usageCount(questionId) {
            return questionnaires.value.filter((q) => usesQuestion(q, questionId)).length;
        }
        // Keep the selected questionnaire pointed at the freshly loaded copy
        watch(questionnaires, (list) => {
            if (selectedQuestionnaire.value?.id && list) {
                selectedQuestionnaire.value = list.find((q) => q.id === selectedQuestionnaire.value.id) || selectedQuestionnaire.value;
            }
        }, { deep: true });
        function showMessage(message) {
            toastMessage.value = message;
            toastColour.value = 'success';
            showToast.value = true;
        }
        function showError(message) {
            toastMessage.value = message || 'An error occurred';
            toastColour.value = 'error';
            showToast.value = true;
        }
        function reload() {
            admin.getQuestionnaires();
            admin.getQuestions();
            addingQuestion.value = false;
            creatingNewQuestion.value = false;
        }
        function showQuestionnaireTab() {
            tabIndex.value = 0;
            reload();
        }
        function showQuestionTab() {
            tabIndex.value = 1;
            admin.getQuestions();
        }
        function selectQuestionnaire(questionnaire) {
            selectedQuestionnaire.value = questionnaire;
            addingQuestion.value = false;
            creatingNewQuestion.value = false;
            expandedQuestionId.value = null;
            showJsonEditor.value = false;
            jsonEditorContent.value = '';
            jsonError.value = '';
        }
        function toggleJsonEditor() {
            jsonError.value = '';
            if (showJsonEditor.value) {
                const parsed = parseJsonEditor();
                if (!parsed)
                    return;
                selectedQuestionnaire.value = parsed;
                showJsonEditor.value = false;
            }
            else {
                jsonEditorContent.value = JSON.stringify(selectedQuestionnaire.value, null, 2);
                showJsonEditor.value = true;
            }
        }
        function parseJsonEditor() {
            try {
                return JSON.parse(jsonEditorContent.value);
            }
            catch (e) {
                jsonError.value = 'Invalid JSON: ' + e.message;
                return null;
            }
        }
        function newQuestionnaire() {
            selectedQuestionnaire.value = {
                id: '',
                key: '',
                title: '',
                isQuiz: false,
                submittedText: '',
                questionnaireQuestions: []
            };
        }
        function saveQuestionnaire() {
            let questionnaire = selectedQuestionnaire.value;
            if (showJsonEditor.value) {
                const parsed = parseJsonEditor();
                if (!parsed)
                    return;
                jsonError.value = '';
                questionnaire = parsed;
                selectedQuestionnaire.value = parsed;
            }
            if (!questionnaire.id) {
                delete questionnaire.id;
                admin.createQuestionnaire(questionnaire, (created) => {
                    selectedQuestionnaire.value = created;
                    showMessage('Questionnaire created');
                });
            }
            else {
                admin.updateQuestionnaire(questionnaire.id, questionnaire, (updated) => {
                    selectedQuestionnaire.value = updated;
                    showMessage('Questionnaire saved');
                });
            }
            creatingNewQuestion.value = false;
        }
        function confirmDeleteQuestionnaire() {
            admin.deleteQuestionnaire(selectedQuestionnaire.value.id, () => {
                selectedQuestionnaire.value = null;
                showMessage('Questionnaire deleted');
            });
            showDeleteQuestionnaireDialog.value = false;
        }
        function cancelAddQuestion() {
            addingQuestion.value = false;
            creatingNewQuestion.value = false;
        }
        function selectExistingQuestion(event) {
            const questionId = event.target.value;
            if (!questionId || !selectedQuestionnaire.value?.id)
                return;
            admin.addQuestionToQuestionnaire(selectedQuestionnaire.value.id, questionId, () => {
                showMessage('Question added to questionnaire');
                cancelAddQuestion();
                reload();
            }, () => showError('Failed to add question to questionnaire'));
        }
        function onQuestionCreated() {
            cancelAddQuestion();
            reload();
        }
        function onLibraryQuestionCreated() {
            creatingLibraryQuestion.value = false;
            admin.getQuestions();
        }
        function toggleQuestion(questionId) {
            expandedQuestionId.value = expandedQuestionId.value === questionId ? null : questionId;
        }
        function toggleLibraryQuestion(questionId) {
            expandedLibraryQuestionId.value = expandedLibraryQuestionId.value === questionId ? null : questionId;
        }
        function dropQuestion(index) {
            const from = draggedIndex.value;
            if (from === null || from === index)
                return;
            const items = [...questionnaireQuestions.value];
            const [moved] = items.splice(from, 1);
            items.splice(index, 0, moved);
            items.forEach((item, i) => (item.order = i + 1));
            selectedQuestionnaire.value.questionnaireQuestions = items;
            draggedIndex.value = null;
            admin.updateQuestionnaire(selectedQuestionnaire.value.id, selectedQuestionnaire.value, () => {
                showMessage('Question order saved');
            });
        }
        function showUsage(question) {
            usageQuestion.value = question;
            showUsageDialog.value = true;
        }
        function viewQuestionnaireFromUsage(questionnaire) {
            showUsageDialog.value = false;
            tabIndex.value = 0;
            selectQuestionnaire(questionnaire);
        }
        onMounted(() => {
            reload();
        });
        return (_ctx, _cache) => {
            const _component_v_snackbar = _resolveComponent("v-snackbar");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("button", {
                            class: _normalizeClass(["tab", { active: tabIndex.value === 0 }]),
                            onClick: showQuestionnaireTab
                        }, "Questionnaires", 2),
                        _createElementVNode("button", {
                            class: _normalizeClass(["tab", { active: tabIndex.value === 1 }]),
                            onClick: showQuestionTab
                        }, "Question Library", 2),
                        _createElementVNode("button", {
                            class: "action-btn secondary ml-auto",
                            onClick: reload
                        }, "🔄 Reload")
                    ]),
                    (tabIndex.value === 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                            _createVNode(AdminListSection, {
                                title: "Questionnaires",
                                items: questionnaires.value,
                                "selected-id": selectedQuestionnaire.value?.id,
                                loading: loading.value,
                                "empty-message": "No questionnaires yet",
                                "search-placeholder": "Search questionnaires...",
                                "search-fields": ['title', 'tags'],
                                "show-new-button": true,
                                "new-button-text": "New Questionnaire",
                                onSelect: selectQuestionnaire,
                                onRefresh: reload,
                                onNew: newQuestionnaire
                            }, {
                                item: _withCtx(({ item }) => [
                                    _createElementVNode("div", _hoisted_4, [
                                        _createElementVNode("div", _hoisted_5, _toDisplayString(item.title), 1),
                                        _createElementVNode("div", _hoisted_6, [
                                            (item.isQuiz)
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_7, "Quiz"))
                                                : _createCommentVNode("", true),
                                            _createTextVNode(" " + _toDisplayString(item.questionnaireQuestions ? item.questionnaireQuestions.length : 0) + " questions ", 1)
                                        ])
                                    ])
                                ]),
                                _: 1
                            }, 8, ["items", "selected-id", "loading"]),
                            _createElementVNode("div", _hoisted_8, [
                                (selectedQuestionnaire.value)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                        _createElementVNode("div", _hoisted_10, [
                                            _createElementVNode("h2", null, _toDisplayString(selectedQuestionnaire.value.title || 'New questionnaire'), 1),
                                            _createElementVNode("div", _hoisted_11, [
                                                _createElementVNode("button", {
                                                    class: "action-btn secondary",
                                                    onClick: toggleJsonEditor
                                                }, _toDisplayString(showJsonEditor.value ? 'Form View' : 'JSON View'), 1),
                                                _createVNode(AdminHeaderActions, {
                                                    "has-id": !!selectedQuestionnaire.value.id,
                                                    onSave: saveQuestionnaire,
                                                    onDelete: _cache[0] || (_cache[0] = ($event) => (showDeleteQuestionnaireDialog.value = true)),
                                                    onNew: newQuestionnaire
                                                }, null, 8, ["has-id"])
                                            ])
                                        ]),
                                        (showJsonEditor.value)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                                _withDirectives(_createElementVNode("textarea", {
                                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((jsonEditorContent).value = $event)),
                                                    class: "json-editor-textarea",
                                                    spellcheck: "false"
                                                }, null, 512), [
                                                    [_vModelText, jsonEditorContent.value]
                                                ]),
                                                (jsonError.value)
                                                    ? (_openBlock(), _createElementBlock("p", _hoisted_13, _toDisplayString(jsonError.value), 1))
                                                    : _createCommentVNode("", true)
                                            ]))
                                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                _createElementVNode("div", _hoisted_14, [
                                                    _createElementVNode("div", _hoisted_15, [
                                                        _cache[22] || (_cache[22] = _createElementVNode("label", null, "Title", -1)),
                                                        _withDirectives(_createElementVNode("input", {
                                                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((selectedQuestionnaire.value.title) = $event)),
                                                            type: "text",
                                                            class: "form-input",
                                                            placeholder: "Enter questionnaire title"
                                                        }, null, 512), [
                                                            [_vModelText, selectedQuestionnaire.value.title]
                                                        ])
                                                    ]),
                                                    _createElementVNode("div", _hoisted_16, [
                                                        _cache[23] || (_cache[23] = _createElementVNode("label", null, "Key", -1)),
                                                        _withDirectives(_createElementVNode("input", {
                                                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((selectedQuestionnaire.value.key) = $event)),
                                                            type: "text",
                                                            class: "form-input",
                                                            placeholder: "Use title with no spaces"
                                                        }, null, 512), [
                                                            [_vModelText, selectedQuestionnaire.value.key]
                                                        ])
                                                    ])
                                                ]),
                                                _createElementVNode("div", _hoisted_17, [
                                                    _createElementVNode("div", _hoisted_18, [
                                                        _cache[24] || (_cache[24] = _createElementVNode("label", null, "Tags", -1)),
                                                        _withDirectives(_createElementVNode("input", {
                                                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((selectedQuestionnaire.value.tags) = $event)),
                                                            type: "text",
                                                            class: "form-input",
                                                            placeholder: "Enter tags"
                                                        }, null, 512), [
                                                            [_vModelText, selectedQuestionnaire.value.tags]
                                                        ])
                                                    ]),
                                                    _createElementVNode("div", _hoisted_19, [
                                                        _createElementVNode("label", _hoisted_20, [
                                                            _withDirectives(_createElementVNode("input", {
                                                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((selectedQuestionnaire.value.isQuiz) = $event)),
                                                                type: "checkbox"
                                                            }, null, 512), [
                                                                [_vModelCheckbox, selectedQuestionnaire.value.isQuiz]
                                                            ]),
                                                            _cache[25] || (_cache[25] = _createTextVNode(" Is quiz "))
                                                        ])
                                                    ])
                                                ]),
                                                _createElementVNode("div", _hoisted_21, [
                                                    _cache[26] || (_cache[26] = _createElementVNode("label", null, "Submitted text", -1)),
                                                    _withDirectives(_createElementVNode("textarea", {
                                                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((selectedQuestionnaire.value.submittedText) = $event)),
                                                        rows: "3",
                                                        class: "form-input",
                                                        placeholder: "Use %SCORE% for quiz score 'x out of y'"
                                                    }, null, 512), [
                                                        [_vModelText, selectedQuestionnaire.value.submittedText]
                                                    ])
                                                ]),
                                                _createElementVNode("div", _hoisted_22, [
                                                    _cache[27] || (_cache[27] = _createElementVNode("label", null, "Return URL", -1)),
                                                    _withDirectives(_createElementVNode("input", {
                                                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((selectedQuestionnaire.value.returnUrl) = $event)),
                                                        type: "text",
                                                        class: "form-input",
                                                        placeholder: "Enter URL to redirect to after submission"
                                                    }, null, 512), [
                                                        [_vModelText, selectedQuestionnaire.value.returnUrl]
                                                    ])
                                                ]),
                                                _createElementVNode("div", _hoisted_23, [
                                                    _createElementVNode("div", _hoisted_24, [
                                                        _createElementVNode("h2", null, "Questions (" + _toDisplayString(questionnaireQuestions.value.length) + ")", 1),
                                                        (!addingQuestion.value)
                                                            ? (_openBlock(), _createElementBlock("button", {
                                                                key: 0,
                                                                class: "action-btn secondary",
                                                                disabled: !selectedQuestionnaire.value.id,
                                                                onClick: _cache[8] || (_cache[8] = ($event) => (addingQuestion.value = true))
                                                            }, " ➕ Add Question ", 8, _hoisted_25))
                                                            : _createCommentVNode("", true)
                                                    ]),
                                                    (addingQuestion.value)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                                                            (!creatingNewQuestion.value)
                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                                                    _createElementVNode("div", _hoisted_28, [
                                                                        _cache[29] || (_cache[29] = _createElementVNode("label", null, "Select an existing question", -1)),
                                                                        _createElementVNode("select", {
                                                                            class: "form-input",
                                                                            onChange: _cache[9] || (_cache[9] = ($event) => (selectExistingQuestion($event)))
                                                                        }, [
                                                                            _cache[28] || (_cache[28] = _createElementVNode("option", { value: "" }, "Choose a question...", -1)),
                                                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(questions.value, (q) => {
                                                                                return (_openBlock(), _createElementBlock("option", {
                                                                                    key: q.id,
                                                                                    value: q.id
                                                                                }, _toDisplayString(q.text), 9, _hoisted_29));
                                                                            }), 128))
                                                                        ], 32)
                                                                    ]),
                                                                    _createElementVNode("div", _hoisted_30, [
                                                                        _createElementVNode("button", {
                                                                            class: "action-btn primary",
                                                                            onClick: _cache[10] || (_cache[10] = ($event) => (creatingNewQuestion.value = true))
                                                                        }, "➕ Create New Question"),
                                                                        _createElementVNode("button", {
                                                                            class: "action-btn secondary",
                                                                            onClick: cancelAddQuestion
                                                                        }, "Cancel")
                                                                    ])
                                                                ]))
                                                                : (_openBlock(), _createBlock(QuestionCard, {
                                                                    key: 1,
                                                                    question: blankQuestion.value,
                                                                    "questionnaire-id": selectedQuestionnaire.value.id,
                                                                    "init-edit-mode": true,
                                                                    "is-new-question": true,
                                                                    onCreated: onQuestionCreated,
                                                                    onCancelNew: cancelAddQuestion,
                                                                    onMessage: showMessage,
                                                                    onError: showError
                                                                }, null, 8, ["question", "questionnaire-id"]))
                                                        ]))
                                                        : _createCommentVNode("", true),
                                                    (questionnaireQuestions.value.length > 0)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(questionnaireQuestions.value, (qq, index) => {
                                                                return (_openBlock(), _createElementBlock("div", {
                                                                    key: qq.questionId,
                                                                    class: "question-item",
                                                                    draggable: "true",
                                                                    onDragstart: ($event) => (draggedIndex.value = index),
                                                                    onDragover: _cache[11] || (_cache[11] = _withModifiers(() => { }, ["prevent"])),
                                                                    onDragenter: _cache[12] || (_cache[12] = _withModifiers(() => { }, ["prevent"])),
                                                                    onDrop: ($event) => (dropQuestion(index)),
                                                                    onDragend: _cache[13] || (_cache[13] = ($event) => (draggedIndex.value = null))
                                                                }, [
                                                                    _createElementVNode("div", {
                                                                        class: "question-item-header",
                                                                        onClick: ($event) => (toggleQuestion(qq.questionId))
                                                                    }, [
                                                                        _cache[30] || (_cache[30] = _createElementVNode("span", { class: "drag-handle" }, "⋮⋮", -1)),
                                                                        _createElementVNode("span", _hoisted_34, _toDisplayString(expandedQuestionId.value === qq.questionId ? '▾' : '▸'), 1),
                                                                        _createElementVNode("span", _hoisted_35, _toDisplayString(qq.question.text), 1)
                                                                    ], 8, _hoisted_33),
                                                                    (expandedQuestionId.value === qq.questionId)
                                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                                                                            _createVNode(QuestionCard, {
                                                                                question: qq.question,
                                                                                "questionnaire-id": selectedQuestionnaire.value.id,
                                                                                onChange: reload,
                                                                                onMessage: showMessage,
                                                                                onError: showError
                                                                            }, null, 8, ["question", "questionnaire-id"])
                                                                        ]))
                                                                        : _createCommentVNode("", true)
                                                                ], 40, _hoisted_32));
                                                            }), 128))
                                                        ]))
                                                        : (_openBlock(), _createElementBlock("div", _hoisted_37, "No questions added yet."))
                                                ])
                                            ], 64))
                                    ]))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_38, _cache[31] || (_cache[31] = [
                                        _createElementVNode("p", null, "Select a questionnaire to view its details", -1)
                                    ])))
                            ])
                        ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_39, [
                            _createElementVNode("div", _hoisted_40, [
                                _createElementVNode("div", null, [
                                    _cache[32] || (_cache[32] = _createElementVNode("h2", null, "Question Library", -1)),
                                    _createElementVNode("p", _hoisted_41, _toDisplayString(filteredLibraryQuestions.value.length) + " of " + _toDisplayString(questions.value.length) + " questions", 1)
                                ]),
                                _createElementVNode("button", {
                                    class: "action-btn primary",
                                    onClick: _cache[14] || (_cache[14] = ($event) => (creatingLibraryQuestion.value = true))
                                }, "➕ Create New Question")
                            ]),
                            _createElementVNode("div", _hoisted_42, [
                                _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event) => ((librarySearch).value = $event)),
                                    type: "text",
                                    class: "form-input",
                                    placeholder: "Search questions by text..."
                                }, null, 512), [
                                    [_vModelText, librarySearch.value]
                                ])
                            ]),
                            (creatingLibraryQuestion.value)
                                ? (_openBlock(), _createBlock(QuestionCard, {
                                    key: 0,
                                    question: blankQuestion.value,
                                    "init-edit-mode": true,
                                    "is-new-question": true,
                                    onCreated: onLibraryQuestionCreated,
                                    onCancelNew: _cache[16] || (_cache[16] = ($event) => (creatingLibraryQuestion.value = false)),
                                    onMessage: showMessage,
                                    onError: showError
                                }, null, 8, ["question"]))
                                : _createCommentVNode("", true),
                            (filteredLibraryQuestions.value.length > 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredLibraryQuestions.value, (q) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                            key: q.id,
                                            class: "question-item"
                                        }, [
                                            _createElementVNode("div", {
                                                class: "question-item-header",
                                                onClick: ($event) => (toggleLibraryQuestion(q.id))
                                            }, [
                                                _createElementVNode("span", _hoisted_45, _toDisplayString(expandedLibraryQuestionId.value === q.id ? '▾' : '▸'), 1),
                                                _createElementVNode("span", _hoisted_46, _toDisplayString(q.text), 1),
                                                _createElementVNode("button", {
                                                    class: "action-btn secondary usage-btn",
                                                    onClick: _withModifiers(($event) => (showUsage(q)), ["stop"])
                                                }, " Usage (" + _toDisplayString(usageCount(q.id)) + ") ", 9, _hoisted_47)
                                            ], 8, _hoisted_44),
                                            (expandedLibraryQuestionId.value === q.id)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                                                    _createVNode(QuestionCard, {
                                                        question: q,
                                                        onChange: reload,
                                                        onMessage: showMessage,
                                                        onError: showError
                                                    }, null, 8, ["question"])
                                                ]))
                                                : _createCommentVNode("", true)
                                        ]));
                                    }), 128))
                                ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_49, "No questions in the library yet."))
                        ]))
                ]),
                _createVNode(MGDialog, {
                    modelValue: showDeleteQuestionnaireDialog.value,
                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event) => ((showDeleteQuestionnaireDialog).value = $event)),
                    title: "Delete Questionnaire",
                    "max-width": "300px",
                    persistent: true
                }, {
                    content: _withCtx(() => [
                        _createElementVNode("p", null, "Are you sure you want to delete \"" + _toDisplayString(selectedQuestionnaire.value?.title) + "\"?", 1)
                    ]),
                    actions: _withCtx(() => [
                        _createVNode(MGButton, {
                            text: "Delete",
                            onClick: confirmDeleteQuestionnaire,
                            stacked: true
                        }),
                        _createVNode(MGButton, {
                            text: "Cancel",
                            outline: true,
                            onClick: _cache[17] || (_cache[17] = ($event) => (showDeleteQuestionnaireDialog.value = false)),
                            stacked: true
                        })
                    ]),
                    _: 1
                }, 8, ["modelValue"]),
                _createVNode(MGDialog, {
                    modelValue: showUsageDialog.value,
                    "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event) => ((showUsageDialog).value = $event)),
                    title: "Questionnaires Using This Question",
                    "max-width": "500px"
                }, {
                    content: _withCtx(() => [
                        _createElementVNode("p", _hoisted_50, _toDisplayString(usageQuestion.value?.text), 1),
                        (usageQuestionnaires.value.length > 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(usageQuestionnaires.value, (q) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                        key: q.id,
                                        class: "usage-item"
                                    }, [
                                        _createElementVNode("div", null, [
                                            _createElementVNode("strong", null, _toDisplayString(q.title), 1),
                                            _createElementVNode("div", _hoisted_52, _toDisplayString(q.isQuiz ? 'Quiz' : 'Questionnaire'), 1)
                                        ]),
                                        _createElementVNode("button", {
                                            class: "action-btn secondary",
                                            onClick: ($event) => (viewQuestionnaireFromUsage(q))
                                        }, "View", 8, _hoisted_53)
                                    ]));
                                }), 128))
                            ]))
                            : (_openBlock(), _createElementBlock("p", _hoisted_54, "This question is not used in any questionnaires yet."))
                    ]),
                    actions: _withCtx(() => [
                        _createVNode(MGButton, {
                            text: "Close",
                            outline: true,
                            onClick: _cache[19] || (_cache[19] = ($event) => (showUsageDialog.value = false)),
                            stacked: true
                        })
                    ]),
                    _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_v_snackbar, {
                    modelValue: showToast.value,
                    "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event) => ((showToast).value = $event)),
                    timeout: 3000,
                    location: "bottom",
                    color: toastColour.value
                }, {
                    default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(toastMessage.value), 1)
                    ]),
                    _: 1
                }, 8, ["modelValue", "color"])
            ], 64));
        };
    }
});
